module.exports = __webpack_public_path__ + "img/sample06.b5683923.gif";